import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import usePermissions from "../../hooks/usePermissions";
import { visibleAdminSections } from "./adminMenu";
import "./admin.css";

/** Administration hub: every admin screen as a tile, grouped; only what the role can view. */
const AdministrationPage = () => {
  const { can, companyWide, isLoading } = usePermissions();
  const sections = visibleAdminSections(companyWide, can);

  return (
    <Layout>
      <div className="container-fluid py-4 px-lg-4">
        <div className="mb-4">
          <h1 className="fw-bold text-dark m-0 page-title">Administration</h1>
          <p className="text-muted small mb-0">
            Company setup, access, data tools and the audit log.
          </p>
        </div>

        {isLoading && (
          <div className="text-center py-5">
            <span
              className="spinner-border text-primary"
              role="status"
              aria-label="Loading"
            ></span>
          </div>
        )}
        {!isLoading && sections.length === 0 && (
          <div className="admin-empty">
            <i className="bi bi-shield-lock"></i>Your role has no access to
            administration screens.
          </div>
        )}

        {sections.map((section) => (
          <section
            key={section.key}
            className="mb-4"
            aria-labelledby={`admin-${section.key}`}
          >
            <h2 id={`admin-${section.key}`} className="admin-section-title">
              {section.title}
            </h2>
            <div className="admin-tiles">
              {section.items.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="admin-tile glass-tile transition-up"
                >
                  <span
                    className="tile-icon rounded-circle d-flex align-items-center justify-content-center"
                    style={{ "--tile-color": item.color }}
                  >
                    <i className={`bi ${item.icon} fs-5`}></i>
                  </span>
                  <span className="admin-tile-text">
                    <span className="admin-tile-title">{item.label}</span>
                    <span className="admin-tile-desc">{item.description}</span>
                  </span>
                  <i className="bi bi-arrow-up-right text-muted small"></i>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </Layout>
  );
};

export default AdministrationPage;
